import connect from './connect'
import EditMeasurementsPage from './EditMeasurementsPage'

export default connect(EditMeasurementsPage)
